import type { ChildProcess } from 'node:child_process';
import { killChildProcessTree } from '../../agents/acp/clients/kill-process-tree.js';
import type { PreviewEnvironmentManagerState } from './state.js';

let registered = false;

/** Best-effort SIGKILL of preview processes when the bridge exits without graceful shutdown. */
export function registerPreviewEnvironmentExitCleanup(state: PreviewEnvironmentManagerState): void {
  if (registered) return;
  registered = true;
  process.on('exit', () => {
    for (const proc of state.processes.values()) {
      killChildProcessTree(proc, 'SIGKILL');
    }
  });
}

export function killPreviewEnvironmentProcessTree(
  proc: ChildProcess,
  signal: NodeJS.Signals = 'SIGTERM',
): void {
  killChildProcessTree(proc, signal);
}
